import { baseState, baseMutations } from '@/store/mixins'
import healthCategory from '@/api/health-category'

export const state = {
  ...baseState
}
export const getters = {}
export const mutations = {
  ...baseMutations
}
export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return healthCategory.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  create (context, data) {
    return healthCategory.store(data)
  },
  update (context, data) {
    return healthCategory.update(data)
  },
  delete (context, data) {
    return healthCategory.destroy(data)
  }
}
